import ButtonComponent from '../../Buttons/ButtonComponent';

import withComponentName from '../../../decorators/withComponentName';

import Styles from '../styles.module.scss';

const AboutUsLocationSection = () => (
  <div className={Styles['about-location-section']}>
    <div className={Styles.section}>
      <h2>Locations</h2>
      <div className={Styles['flex-wrapper']}>
        <div className={Styles['about-location']}>
          <iframe height="157" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2483.4445359967594!2d-0.02091099999998774!3d51.50506000000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487602cdae6dbaed%3A0x6ec7d6d13c8a5dbc!2sOne+Canada+Square!5e0!3m2!1sen!2suk!4v1409758098638" width="100%" />
          <div className={Styles['about-location-cnt']}>
            <h4>United Kingdom</h4>
            <address>
              <p>Level39,</p>
              <p>One Canada Square,</p>
              <p>Canary Wharf,</p>
              <br />
              <p>London</p>
            </address>
          </div>
        </div>
        <div className={Styles['about-location']}>
          <iframe height="157" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d344.27534939145977!2d36.23651274202731!3d49.994353142437056!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4127a0efb04d1f41%3A0xe32579cac9827c50!2sTeatral&#39;nyi%20Ln%2C%204%2C%20Kharkiv%2C%20Kharkivs&#39;ka%20oblast%2C%2061000!5e0!3m2!1sen!2sua!4v1587931707506!5m2!1sen!2sua" width="100%" />
          <div className={Styles['about-location-cnt']}>
            <h4>Ukraine</h4>
            <address>
              <p>Office Center «Poetry»,</p>
              <p>Theater Lane 4,</p>
              <br />
              <br />
              <p>Kharkiv</p>
            </address>
          </div>
        </div>
        <div className={Styles['about-location']}>
          <iframe height="157" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3231.6658092587168!2d14.491129151147462!3d35.90619972511035!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x130e457221f05873%3A0xcf3a951e93c9327d!2sSOHO%20Office%20(Savoy%20Gardens)%20-%20Serviced%20Office%20Space!5e0!3m2!1sen!2sua!4v1587931985801!5m2!1sen!2sua" width="100%" />
          <div className={Styles['about-location-cnt']}>
            <h4>Malta</h4>
            <address>
              <p>SOHO Office (Savoy Gardens)</p>
              <p>Triq D'Argens</p>
              <br />
              <br />
              <p>Gzira</p>
            </address>
          </div>
        </div>
      </div>
      <p className={Styles['about-location-bottom-text']}>If you would like more information or to provide feedback, feel free to </p>
      <ButtonComponent
        value="Contact Us"
        path="/contact-us"
        green
      />
    </div>
  </div>
);

export default withComponentName(AboutUsLocationSection);
